module.exports = __webpack_public_path__ + "static/media/share.d14a4d47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/navbar/share.svg
// module id = 2239
// module chunks = 0